import {validateValue} from './helpers/validation'

export function validateInput(e, field) {
  return validate(e.target.value, field)
}

export function validateCheckbox(e, field) {
  return validate(e.target.checked, field)
}

export function setFormState(formState) {
  return {
    type: 'SET_FORM_STATE',
    formState
  }
}

export function validate(value, field) {
  field = validateValue(value, field);

  return {
    type: 'VALIDATE',
    field
  }
}
